import { defaultCountries, guessCountryByPartialPhoneNumber, removeDialCode } from 'react-international-phone';
import { COUNTRY_CODE_US, findCountryByIso } from './country-data-utils';
export const parsePhoneNumber = (phone) => {
    let parsedPhone;
    if (phone) {
        const { country } = guessCountryByPartialPhoneNumber({ phone });
        if ((country === null || country === void 0 ? void 0 : country.dialCode) && phone.includes(country.dialCode)) {
            const lineNumber = removeDialCode({ phone, dialCode: country.dialCode });
            parsedPhone = {
                countryCode: +country.dialCode,
                phoneNumber: lineNumber,
            };
        }
    }
    return parsedPhone;
};
export const getDefaultCountries = () => defaultCountries;
export const getPhoneDataFromCountryIso = (organizationCountryIso) => {
    const organizationCountry = findCountryByIso(organizationCountryIso) || findCountryByIso(COUNTRY_CODE_US);
    const countryIsoCode = organizationCountry[1];
    const countryDialCode = organizationCountry[2];
    return {
        phone: `+${countryDialCode}`,
        countryIso: countryIsoCode,
    };
};
